module.exports = __webpack_public_path__ + "img/logo_circle.56243cda.png";